<template>
    <!-- TODO: Fix typing of state -->
    <Form :schema="CreateAssignmentSchema" :state="state as Partial<any>" @submit="onSubmit">
        <FormField label="Tittel" name="title">
            <Input v-model="state.title"/>
        </FormField>
        <FormField label="Beskrivelse" name="description">
            <Input v-model="state.description"/>
        </FormField>
        <Button type="submit">Opprett</Button>
    </Form>
</template>

<script setup lang="ts">

import {ref} from 'vue'
import Form from '@nuxt/ui/components/Form.vue'
import FormField from '@nuxt/ui/components/FormField.vue'
import Input from '@nuxt/ui/components/Input.vue'
import Button from '@nuxt/ui/components/Button.vue'
import { ASSIGNMENT_CREATED, createAssignment} from '@/assignments/assignment.service'
import type {FormSubmitEvent} from '@nuxt/ui'
import emitter from '@/services/infrastructure/emitter'
import {AssignmentFormOutput, CreateAssignmentCommand, CreateAssignmentSchema} from '@/assignments/Assignment.type'

const initialState: Partial<CreateAssignmentCommand> = {
    title: undefined,
    description: undefined,
    type: 'FrontendAssignment',
    resourceLinks: []
}

const state = ref<Partial<CreateAssignmentCommand>>({...initialState})

const onSubmit = async (event: FormSubmitEvent<AssignmentFormOutput>) => {
    await createAssignment(event.data)
    emitter.emit(ASSIGNMENT_CREATED)
    Object.assign(state, initialState)
}
</script>

<style scoped>

</style>